/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profile_Security_Remove_Passkey_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to remove '{name}'? This action cannot be undone." |
*
* @param {Profile_Security_Remove_Passkey_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_remove_passkey_description = /** @type {((inputs: Profile_Security_Remove_Passkey_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Remove_Passkey_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Bist du sicher, dass du '${i?.name}' entfernen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to remove '${i?.name}'? This action cannot be undone.`)
});